document.addEventListener('DOMContentLoaded', function () {
  document
    .getElementById('calculate_btn')
    .addEventListener('click', calculateCBD);

  function calculateCBD() {
    console.log('function run...');
    
    const output = document.getElementById('dosage_output');

    const weight = parseFloat(document.getElementById('weight_kg').value);
    const sex = document.getElementById('sex').value;
    const intensity = document.getElementById('intensity').value;
    const cbdPercent = parseInt(document.getElementById('cbd_percent').value);
    const carrierOil = document.getElementById('carrier_oil').value;
    const spectrum = document.getElementById('spectrum').value;




    /* ======================
       VALIDATION
    ====================== */

    if (isNaN(weight) || weight < 30 || weight > 200) {
      output.innerText = window.cbdMessages.weightError;
      return;
    }

    if (!['male', 'female'].includes(sex)) {
      output.innerText = window.cbdMessages.sexError;
      return;
    }

    if (!['weak', 'medium', 'strong'].includes(intensity)) {
      output.innerText = window.cbdMessages.intensityError;
      return;
    }

    const allowedCBD = [5, 10, 15, 20, 25, 30, 40];
    if (!allowedCBD.includes(cbdPercent)) {
      output.innerText = window.cbdMessages.cbdError;
      return;
    }

    /* ======================
       STEP 1: mg per drop
       (CBD % strength)
    ====================== */
    let mgPerDrop;
    switch (cbdPercent) {
      case 5:  mgPerDrop = 2;  break;
      case 10: mgPerDrop = 4;  break;
      case 15: mgPerDrop = 6;  break;
      case 20: mgPerDrop = 8;  break;
      case 25: mgPerDrop = 10; break;
      case 30: mgPerDrop = 12; break;
      case 40: mgPerDrop = 16; break;
    }

    /* ======================
       STEP 2: intensity
       (mg/kg/day)
    ====================== */
    let targetMgPerKg;
    switch (intensity) {
      case 'weak':   targetMgPerKg = 0.25; break;
      case 'medium': targetMgPerKg = 0.5;  break;
      case 'strong': targetMgPerKg = 0.75; break;
    }

    /* ======================
       STEP 3: sex factor
       (small adjustment)
    ====================== */
    const sexFactor = sex === 'female' ? 0.95 : 1.0;

    /* ======================
       STEP 4: carrier oil
       (bioavailability)
    ====================== */
    let carrierFactor = 1.0; // default / neutral
    if (carrierOil === 'olive') carrierFactor = 0.9;
    if (carrierOil === 'hemp') carrierFactor = 0.85;
    if (carrierOil === 'mct') carrierFactor = 1.1; // higher bioavailability

    /* ======================
       STEP 5: spectrum
       (effect strength)
    ====================== */
    let spectrumFactor = 1.0;
    if (spectrum === 'full') spectrumFactor = 1.1;   // stronger
    if (spectrum === 'broad') spectrumFactor = 1.0;  // baseline

    /* ======================
       STEP 6: mg/day
    ====================== */
    const recommendedMgPerDay =
      (weight * targetMgPerKg * sexFactor) /
      (carrierFactor * spectrumFactor);

    /* ======================
       STEP 7: drops/day
    ====================== */
    const dropsPerDay = recommendedMgPerDay / mgPerDrop;
    const roundedDrops = Math.round(dropsPerDay);

    /* ======================
       FINAL OUTPUT
    ====================== */
    // output.innerText =
    //   `Recommended dosage: ${roundedDrops} drops per day (±1 drop)`;
    const finalText = window.cbdMessages.resultPrefix.replace("[drops]",roundedDrops);
    // output.innerText = finalText;
    document.querySelector('.omnisend_wrapper').style.display = 'block';
    document.querySelector('.omnisend_wrapper input[name="custom_recommended_dosage"]').value = finalText;
  }
});